import createCachedSelector from 're-reselect';

import { getDefaultVisitingCardEditorData } from '../../service/VisitingCardEditorHelpers/VisitingCardEditorHelpers';
import { MetroStationInfo } from '../../typings/banners';
import { State } from '../../typings/state';
import {
    VisitingCardEditorsState,
    VisitingCardEditorState
} from '../../typings/VisitingCardEditor';

export const selectVisitingCardEditorValue = createCachedSelector(
    (state: State) => state.visitingCardEditor,
    (state: State, editorId: string) => editorId,
    (
        editors: VisitingCardEditorsState,
        editorId: string
    ): VisitingCardEditorState => {
        return editors[editorId] || getDefaultVisitingCardEditorData();
    }
)((state: State, editorId: string) => editorId);

export const selectVisitingCardEditorMetroStations = createCachedSelector(
    selectVisitingCardEditorValue,
    (state: State) => state.commonData.metroStations,
    (
        visitingCardEditor: VisitingCardEditorState,
        metroStations?: Record<number, Array<MetroStationInfo>>
    ): Array<MetroStationInfo> | undefined => {
        const { vCardData } = visitingCardEditor;

        if (!metroStations || !vCardData) {
            return undefined;
        }

        return metroStations[vCardData.geoId];
    }
)((state: State, editorId: string) => editorId);
